import React, { FC } from 'react';

import styled from 'styled-components/macro';

import media from 'helpers/media';
import theme from 'theme';

type ColumnProps = {
    cols?: number;
    mobile?: number;
    tablet?: number;
    laptop?: number;
    desktop?: number;
};

const widths = {
    $mobile: 25,
    $tablet: 41,
    $laptop: 60,
    $desktop: 72,
};

const getCssMobile = (m: number): string => {
    const style =
        m >= 4
            ? `width: calc(100% - ${theme.space.base});`
            : `width: calc(${m * widths.$mobile}% - ${theme.space.base});`;

    return style;
};

const getCssTablet = (t: number): string => {
    const style = `width: ${widths.$tablet * t + 16 * t - 16}px`;
    return style;
};

const getCssLaptop = (l: number): string => {
    const style = `width: ${widths.$laptop * l + 24 * l - 24}px`;
    return style;
};

const getCssDesktop = (d: number): string => {
    const style = `width: ${widths.$desktop * d + 24 * d - 24}px`;
    return style;
};

const ColumnStyled = styled.div<{
    $cols: number;
    $mobile: number;
    $tablet: number;
    $laptop: number;
    $desktop: number;
}>`
    box-sizing: border-box;
    margin-left: ${({ theme }) => theme.space.base};
    

    ${({ $cols, $mobile }) => media.mobile`
        ${getCssMobile($mobile > 0 ? $mobile : $cols)};
    `}

    ${({ $cols, $tablet }) => media.tablet`
        ${getCssTablet($tablet > 0 ? $tablet : $cols)};
    `}

    ${({ $cols, $laptop }) => media.laptop`
        margin-left: ${theme.space.medium};
        ${getCssLaptop($laptop > 0 ? $laptop : $cols)};
    `}

    ${({ $cols, $desktop }) => media.desktop`
        margin-left: ${theme.space.medium};
        ${getCssDesktop($desktop > 0 ? $desktop : $cols)};
    `}
`;

const Column: FC<ColumnProps & React.HTMLAttributes<HTMLDivElement>> = ({
    cols = 12,
    mobile = 0,
    tablet = 0,
    laptop = 0,
    desktop = 0,
    ...rest
}) => {
    return (
        <ColumnStyled
            $cols={typeof cols === 'undefined' ? 12 : cols}
            $mobile={typeof mobile === 'undefined' ? 0 : mobile}
            $tablet={typeof tablet === 'undefined' ? 0 : tablet}
            $laptop={typeof laptop === 'undefined' ? 0 : laptop}
            $desktop={typeof desktop === 'undefined' ? 0 : desktop}
            {...rest}
        >
            {rest.children}
        </ColumnStyled>
    );
};

export default Column;
